import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

export default function ConfirmationDialog({
  isOpen,
  onClose,
  confirmAction,
  loading
}: {
  isOpen: boolean;
  onClose: any;
  confirmAction: any;
  loading:boolean
}) {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Delete Instructor</DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure you want to delete Instructor?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{
            background: '#fff',
            color: '#191A1C',
            justifyContent: 'center',
            fontSize: '16px',
          }}
          onClick={() => {
            onClose();
          }}
          disabled={loading}
        >
          No
        </Button>
        <Button
          sx={{
            justifyContent: 'center',
            fontSize: '16px',
          }}
          onClick={() => {
            confirmAction();
            onClose();
          }}
          disabled={loading}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// export default ConfirmationDialog;
